/**
 * Password Toggle Module
 * Przełącza widoczność hasła w polach typu password.
 * Kliknięcie ikony .text-input__icon--toggle zmienia type input
 * pomiędzy "password" a "text" i podmienia ikonę (eye-open / eye-off).
 */

(function () {
  'use strict';

  var ICON_EYE_OPEN = 'assets/icons/icon-eye-open.svg';
  var ICON_EYE_OFF = 'assets/icons/icon-eye-off.svg';

  var toggleButtons = document.querySelectorAll('.text-input__icon--toggle');

  if (!toggleButtons.length) return;

  toggleButtons.forEach(function (toggleBtn) {
    var body = toggleBtn.closest('.text-input__body');
    if (!body) return;

    var input = body.querySelector('.text-input__field');
    if (!input) return;

    function toggle() {
      var isHidden = input.type === 'password';
      var icon = toggleBtn.querySelector('img');

      input.type = isHidden ? 'text' : 'password';

      if (icon) {
        icon.src = isHidden ? ICON_EYE_OFF : ICON_EYE_OPEN;
      }

      toggleBtn.setAttribute(
        'aria-label',
        isHidden ? 'Ukryj hasło' : 'Pokaż hasło'
      );
    }

    // Click handler
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });

    // Keyboard support — Enter / Space
    toggleBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });
})();
